<template>
  <div>
    <el-dialog v-model="challengePopupShow" title="Tips" width="500" :show-close="false">
      <template #header>
        <div class="close_icon" @click="closePopup">
          <el-icon :size="20">
            <CloseBold />
          </el-icon>
        </div>
      </template>
      <div class="dialog_content">
        <div class="top_image">
          <el-image class="challenge_success" :src="iconPath(
            isSuccess ? 'challenge_success.png' : 'challenge_fail.png'
          )
            "></el-image>
        </div>
        <div class="result_text">
          {{ isSuccess ? "恭喜您~闯关成功" : "很遗憾~闯关失败" }}
        </div>
        <div class="callenge_info">
          <div class="flex Flexalign">
            <div class="info_label">题目数量：</div>
            <div class="info_value ml-15">{{ challengeInfo.num }}题</div>
          </div>
          <div class="flex Flexalign mt-15">
            <div class="info_label">正确率：</div>
            <div class="info_value ml-15">{{ challengeInfo.percent }}</div>
          </div>
          <div class="flex Flexalign mt-15">
            <div class="info_label">答题时间：</div>
            <div class="info_value ml-15">{{ challengeInfo.time }}</div>
          </div>
        </div>
        <div class="btn_analysis cursor_pointer" @click="closePopup">试题分析</div>
        <!-- <div class="info_text cursor_pointer">闯关详情</div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "GjkcH5ChallengePopup",

  data() {
    return {
      challengePopupShow: false,
      isSuccess: false,
      challengeInfo: {
        num: '',
        percent: "",
        time: "",
      },
    };
  },

  mounted() { },

  methods: {
    closePopup() {
      this.challengePopupShow = false;
      this.$emit("back");
    },
  },
};
</script>
<style lang="scss" scoped>
:deep(.el-dialog) {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 0;
  width: 330px;
  min-height: 380px;
  background: linear-gradient(180deg, #fffbf1 0%, #ffffff 100%);
  position: relative;
  top: 160px;
}

:deep(.el-dialog__header) {
  position: relative;
  padding: 0 20px;
  box-sizing: border-box;
  text-align: start;
}

.close_icon {
  position: absolute;
  top: 20px;
  right: 20px;
  color: #333333;
  z-index: 999;
}

.dialog_content {
  width: 100%;

  .top_image {
    position: absolute;

    .challenge_success {
      width: 330px;
      height: 200px;
      top: -100px;
      left: 0;
    }
  }

  .result_text {
    font-weight: 500;
    font-size: 22px;
    color: #111111;
    text-align: center;
    padding-top: 70px;
  }

  .callenge_info {
    width: 290px;
    height: 136px;
    background: #fff4e7;
    border-radius: 10px;
    margin: 15px auto;
    box-sizing: border-box;
    padding: 20px;

    .info_label {
      width: 70px;
      color: #666;
    }

    .info_value {
      color: #333333;
    }
  }

  .btn_analysis {
    margin: 20px auto 10px;
    width: 211px;
    height: 48px;
    background: linear-gradient(180deg, #ffb500 0%, #fe940c 100%);
    box-shadow: 0px 6px 12px 0px rgba(255, 115, 25, 0.31),
      inset 0px -5px 11px 0px #ffc9a2;
    border-radius: 24px;
    border: 1px solid #ffffff;
    line-height: 48px;
    text-align: center;
    font-size: 18px;
    color: #ffffff;
  }

  .info_text {
    font-size: 14px;
    color: #13d6aa;
    text-align: center;
  }
}
</style>